var React = require('react');

function WatermarkInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Video-Preview","fill":"none","fillRule":"evenodd","stroke":"none","strokeWidth":"1"},React.createElement("path",{"id":"Fill-1","fill":"#fff","d":"M43.8529122,128 C70.4370465,127.216274 91.1843228,105.941608 87.2166331,78.1702327 C85.3266146,64.9401033 74.8634428,49.437291 67.9460487,37.4863889 C59.7114061,23.2628039 51.4203451,11.4161532 43.8529122,0 L43.8516857,0 C36.2842528,11.4161532 27.9931918,23.2628039 19.7585493,37.4863889 C12.8411552,49.437291 2.37798338,64.9401033 0.487964882,78.1702327 C-3.47972482,105.941608 17.2675515,127.216274 43.8529122,128"})));
}

WatermarkInline.defaultProps = {"width":"88","height":"128","version":"1.1","viewBox":"0 0 88 128"};

module.exports = WatermarkInline;

WatermarkInline.default = WatermarkInline;
